module.exports = "//public.zight.com/packs/media/images/free@2x-44e8ee06ccf9d8d08d100ad9e009cc92.png";